import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=1c2be4bc&scoped=true"
import script from "./patients.vue?vue&type=script&lang=js"
export * from "./patients.vue?vue&type=script&lang=js"
import style0 from "./patients.vue?vue&type=style&index=0&id=1c2be4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2be4bc",
  null
  
)

export default component.exports